<template>
  <el-button 
    :class="buttonClass" 
    :link="link"
    :plain="plain"
    :disabled="disabled"
    :loading="loading"
    @click="$emit('click')"
  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    link: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    buttonClass() {
      if (this.plain) {
        return {
          "login-btn": true,
          "plain-btn-primary": this.type === "primary",
          "plain-btn-error": this.type === "error",
          "plain-btn-error-2": this.type === "error-2",

        }
      }
      if (this.link) {
        return {
          "link-btn-primary": this.type === "primary",
          "link-btn-primary-2": this.type === "primary-2",
          "link-btn-primary-3": this.type === "primary-3",
          "link-btn-info": this.type === "info",
          "link-btn-info-2": this.type === "info-2",
          "link-btn-error": this.type === "error"
        }
      }
      return {
        "login-btn": true,
        "btn-primary": this.type === "primary",
        "btn-info": this.type === "info",
        "btn-error": this.type === "error",
        "btn-error-2": this.type === "error-2",
        "btn-cancel": this.type === "cancel"
      }
    }
  }
}
</script>

<style scoped>
.login-btn {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  border-radius: 4px;
  height: 42px;
}
.login-btn.is-disabled {
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  background: #E0E0E0;
  color: #525252;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px; 
}
.login-btn.el-button+.el-button {
  margin-left: 0;
}
.el-button+.login-btn.el-button {
  margin-left: 0;
}
.btn-primary, .btn-primary:hover  {
  border: 1px solid #20A8C3;
  background: #20A8C3;
  color: #FFFFFF;
}
.btn-info, .btn-info:hover {
  border-radius: 4px;
  border: 1px solid #C9CACD;
  background: #E6E6E6;
  color: #4A4A4A;
}

.btn-error, .btn-error:hover {
  border-radius: 4px;
  border: 1px solid #FF1D00;
  background: #FF1D00;
  color: #FFFFFF;
}

.btn-error-2, .btn-error-2:hover {
  border-radius: 4px;
  border: 1px solid #FF1D00;
  background: #FF1D00;
  color: #FFFFFF;
}

.link-btn-primary.el-button.is-link {
  color: #3498DB;
}
.link-btn-primary.el-button.is-link.is-disabled {
  color: #8D8D8D;
}
.link-btn-primary-2.el-button.is-link, .link-btn-primary-2.el-button.is-link:hover {
  color: #20A8C3;
}

.link-btn-primary-3.el-button.is-link, .link-btn-primary-3.el-button.is-link:hover {
  color: #20A7C1;
}
.link-btn-info.el-button.is-link {
  color: #8D8D8D;
}
.link-btn-info-2.el-button.is-link {
  color: #525252;
}
.link-btn-error.el-button.is-link, .link-btn-error.el-button.is-link:hover {
  color: #FF1D00;
}
.plain-btn-primary {
  border: 1px solid #20A8C3;
  color: #20A8C3;
}
.plain-btn-error {
  border: 1px solid #DF4430;
  color: #DF4430;
}
.plain-btn-error-2, .plain-btn-error-2:hover    {
  border: 1px solid #DF4430;
  background-color: #DF4430;
  color: #fff ;
}
.plain-btn-white, .plain-btn-white:hover {
  border: 1px solid white;
  color: white;
  background-color: transparent;
}
.btn-cancel, .btn-cancel:hover {
  border-radius: 5px;
  border: 1px solid #F3F3F3;
  background: #F3F3F3;
  color: #4A4A4A; 
}
</style>
